import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import DateSelection from "@/components/dateSelection";
import { StyledPaper } from "@/styles/mui/globalStyles";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { SearchingBar } from "@/components/DataTable/searchingBar";
import {
  ButtonSendTheme,
  SearchBarTheme,
  TableListTheme,
} from "@/styles/mui/tableListTheme";
// CSS
import "@/styles/page/systemSettingProductPage.css";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";

// Navigate
import { useLocation, useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { stocktakeTableColumn } from "@/config/tableColumnConfig";

// Mui Icon
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
// Moment
import moment from "moment";
import "moment/locale/zh-hk";
import { useSelector } from "react-redux";

// Fetch
import { exportStocktakeSummary, getStocktakeList } from "@/fetch/fetchStock";
import { useCurrentAction } from "@/hooks/user";

const StocktakePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const defaultStartDate = moment().subtract(1, "month").startOf("month");
  const defaultEndDate = moment().endOf("month");
  // States
  const [productData, setProductData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [filterAdmin, setFilterAdmin] = React.useState(true);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const [isLoading, setLoading] = React.useState(false);
  const [searchStaffCode, setSearchStaffCode] = React.useState("");
  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getStocktakeList(
        filterAdmin,
        startDate,
        endDate,
        searchStaffCode
      ).then((data) => {
        if (data && data.results) {
          setProductData(data.data);
        } else {
          setProductData([]);
        }
        setLoading(false);
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };
  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });
  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };
  const onCellClick = (data) => {
    navigate(`/stocktake/${data.row.id}`);
  };
  const exportStocktakeReport = async () => {
    const formatStartDate = moment(startDate).format("YYYY-MM-DD");
    const formatEndDate = moment(endDate).format("YYYY-MM-DD");
    await exportStocktakeSummary(
      filterAdmin,
      formatStartDate,
      formatEndDate,
      searchStaffCode
    ).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Stocktake Report (${formatStartDate} - ${formatEndDate}).xlsx`
      );
      document.body.appendChild(link);
      link.click();
    });
  };
  React.useEffect(() => {
    fetchAll();

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterAdmin]);

  return (
    <Layout
      selectedIndex={19}
      header="stocktakePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="盤點"
        history={() => navigate(-1)}
        children={
          actions?.download ? (
            <div>
              <IconButton
                component="label"
                onClick={() => setFilterAdmin(!filterAdmin)}
              >
                {filterAdmin ? <FilterAltIcon /> : <FilterAltOffIcon />}
              </IconButton>

              <IconButton
                component="label"
                onClick={() => exportStocktakeReport()}
              >
                <DownloadIcon />
              </IconButton>
            </div>
          ) : null
        }
      />
      <StyledPaper page={"yes"} alignItems={"left"}>
        <ThemeProvider theme={theme}>
          <Grid container spacing={2} size={12}>
            <DateSelection
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
              xs={12}
              md={4}
              lg={4}
            ></DateSelection>
            <Grid
              size={{
                xs: 12,
                md: 2,
                lg: 2,
              }}
            >
              <ThemeProvider theme={SearchBarTheme}>
                <SearchingBar
                  value={searchStaffCode}
                  startAdornment={false}
                  clearSearch={() => setSearchStaffCode("")}
                  onChange={(event) => setSearchStaffCode(event.target.value)}
                  placeholder="員工編號"
                />
              </ThemeProvider>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 2,
                lg: 2,
              }}
            >
              <ThemeProvider theme={ButtonSendTheme}>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LoadingButton
                    size="small"
                    onClick={() => {
                      setLoading(true);
                      fetchAll();
                    }}
                    endIcon={<SearchOutlinedIcon fontSize="small" />}
                    loading={isLoading}
                    loadingPosition="end"
                    variant="contained"
                  >
                    搜尋
                  </LoadingButton>
                </div>
              </ThemeProvider>
            </Grid>
          </Grid>
        </ThemeProvider>
      </StyledPaper>
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            isCellEditable={false}
            rows={productData}
            columns={stocktakeTableColumn}
            pageSize={100}
            onCellClick={(data) => onCellClick(data)}
            initialState={{
              sorting: {
                sortModel: [{ field: "brand_types_name", sort: "asc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default StocktakePage;
